/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { User } from '@/client';

export interface UserFormatted extends User {
  key: React.Key;
  roleFormatted: string;
  dateCreatedDate: Date;
}

export type Role = User['role'];

export enum ActionType {
  VIEW = 'viewUser',
  ASSIGN = 'assignUser',
  DELETE = 'deleteUser',
  MAKE_SUBTENANT_ONLY = 'makeSubtenantOnly',
  MAKE_TENANT_USER = 'makeTenantUser',
  MAKE_SUPERADMIN = 'makeSuperadmin',
  MAKE_ADMIN = 'makeAdmin',
  MAKE_EDITOR = 'makeEditor',
  MAKE_VIEWER = 'makeViewer',
}

export const RoleAction: Partial<Record<Role, ActionType>> = {
  superadmin: ActionType.MAKE_SUPERADMIN,
  admin: ActionType.MAKE_ADMIN,
  editor: ActionType.MAKE_EDITOR,
  viewer: ActionType.MAKE_VIEWER,
};

export function formatUserForTable(user: User, roleFormatted: string): UserFormatted {
  return {
    ...user,
    key: user.id,
    roleFormatted,
    dateCreatedDate: new Date(user.dateCreated),
  };
}
